import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import ReferralSourceList from 'components/referralSources/ReferralSourceList';
import CircularProgress from 'components/shared/CircularProgress';
import { adminClientsQueryKeys, adminShowClient } from 'services/api/admin/clients';

// Admin > Clients > (three dot menu) > Referral Sources. The same screen the customer sees, pointed
// at a chosen client, so Olio staff can set a customer's list up during onboarding. Mirrors
// AdminUserPreferences, which does this for notification preferences.
//
// The client is fetched only to title the page — the list itself is addressed by the id in the path.
export default function AdminReferralSources() {
  const { id } = useParams<{ id: string }>();

  const { data: client, isLoading } = useQuery({
    queryKey: adminClientsQueryKeys.show(id!),
    queryFn: ({ signal }) => adminShowClient(id!, signal),
    enabled: !!id,
  });

  if (isLoading) return <CircularProgress />;

  return <ReferralSourceList clientId={id} isAdmin title={`Referral Sources${client ? ` — ${client.name}` : ''}`} />;
}
